import { I18n } from '@calendly/i18n';
import { PhoneNumberWithFlagNoSuspense as PhoneNumberWithFlag, useNumberInfo } from '@calendly/telephone-tools';
import { BareButton } from '@calendly/ui/components/bare-button';
import { CloseIcon } from '@calendly/ui/components/icons';
import { TextInput } from '@calendly/ui/components/text-input';
import { useDeviceType } from '@calendly/ui/hooks/use-device-type';
import { colorTextSecondary } from '@calendly/ui/theme';
import classNames from 'classnames';
import { useCallback, forwardRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { phoneNumbersSelector, phoneNumbersLimitReachedSelector, removePhoneNumberConfirmation } from 'features/phone_numbers';
import { RemovePopup } from './remove_popup';
const phoneNumbersContainerIsPhoneCss = "p7ldb2m";
const phoneNumbersContainerCss = "pd8pe4n";
const PhoneNumbersContainer = forwardRef((props, ref) => {
  const isPhone = useDeviceType('isPhone');
  return <TextInput ref={ref} {...props} className={classNames(phoneNumbersContainerCss, {
    [phoneNumbersContainerIsPhoneCss]: isPhone
  }, props.className)} />;
});
const deactivatedPhoneNumbersContainerCss = "d1gziuka";
const DeactivatedPhoneNumbersContainer = forwardRef((props, ref) => <PhoneNumbersContainer ref={ref} {...props} className={classNames(deactivatedPhoneNumbersContainerCss, props.className)} />);
const phoneNumberContainerCss = "p1sqzmm7";
const PhoneNumberContainer = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(phoneNumberContainerCss, props.className)} />;
});
const removeButtonCss = "r4kkxrl";
const RemoveButton = forwardRef((props, ref) => <BareButton ref={ref} {...props} className={classNames(removeButtonCss, props.className)} />);
const sMSErrorCss = "s1n2es9q";
const SMSError = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(sMSErrorCss, props.className)} />;
});
const errorBadgeCss = "em5us0v";
const ErrorBadge = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'strong';
  return <Component ref={ref} {...restProps} className={classNames(errorBadgeCss, props.className)} />;
});
const PhoneField = ({
  deactivated,
  uuid,
  number,
  onRemove
}) => {
  const phoneNumber = <PhoneNumber uuid={uuid} number={number} onRemove={onRemove} />;
  if (deactivated) {
    return <DeactivatedPhoneNumbersContainer as="div" key={uuid} data-testid="phoneNumber">
        {phoneNumber}
      </DeactivatedPhoneNumbersContainer>;
  }
  return <PhoneNumbersContainer as="div" key={uuid} data-testid="phoneNumber">
      {phoneNumber}
    </PhoneNumbersContainer>;
};
const PhoneNumber = ({
  uuid,
  number,
  onRemove
}) => {
  const onRemoveClick = useCallback(() => {
    onRemove(uuid);
  }, [uuid, onRemove]);
  return <PhoneNumberContainer>
      <PhoneNumberWithFlag phoneNumber={number} />
      <RemoveButton onClick={onRemoveClick} aria-label={I18n.t('publisher.account_settings.phone_numbers.remove.button_label', {
      phone_number: number
    })}>
        <CloseIcon color={colorTextSecondary} />
      </RemoveButton>
    </PhoneNumberContainer>;
};
const PhoneFieldContainer = ({
  uuid,
  number,
  onRemove
}) => {
  const {
    countryCode,
    supportedCountry
  } = useNumberInfo(number);
  const phoneFieldProps = {
    uuid,
    number,
    onRemove,
    deactivated: !supportedCountry
  };
  return <>
      <PhoneField {...phoneFieldProps} />
      {!supportedCountry && <SMSError>
            <ErrorBadge>!</ErrorBadge>
            {' '}
            {I18n.t(`publisher.account_settings.phone_numbers.country_no_longer_supported.${countryCode.toLowerCase()}`)}
          </SMSError>}
    </>;
};
export const PhoneNumbersList = () => {
  const dispatch = useDispatch();
  const phoneNumbers = useSelector(phoneNumbersSelector);
  const isLimitReached = useSelector(phoneNumbersLimitReachedSelector);
  const onRemove = useCallback(uuid => {
    dispatch(removePhoneNumberConfirmation(uuid));
  }, [dispatch]);
  return <>
      {phoneNumbers.map(({
      e164_phone_number: number,
      uuid
    }) => <PhoneFieldContainer uuid={uuid} key={uuid} number={number} onRemove={onRemove} />)}
      {isLimitReached && I18n.t('publisher.account_settings.phone_numbers.limit')}

      <RemovePopup />
    </>;
};

require("./phone_numbers_list.wyw-in-js.css!=!../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./phone_numbers_list.js");